import { useAtom } from '@reatom/npm-react'

import { isTauriOrBrowserLocalAtom } from '@root/shared/core'

import type React from 'react'

type TauriEnvironmentProps = {
  children: React.ReactNode
  otherwise?: React.ReactNode
}

export const TauriEnvironment: React.FC<TauriEnvironmentProps> = ({
  children,
  otherwise,
}) => {
  const [isTauri] = useAtom(isTauriOrBrowserLocalAtom)

  if (isTauri) {
    return children
  }

  return otherwise
}
